import { render } from "./board.vue?vue&type=template&id=1e7ff4a5&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"

import "./board.vue?vue&type=style&index=0&id=1e7ff4a5&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7ff4a5"]])

export default __exports__